var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4464dc93a7103eb7e9639b241963cd5dff73c66c"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["war-and-peace@fictive-kin"]={id:"4464dc93a7103eb7e9639b241963cd5dff73c66c"};
      